module.exports = __webpack_public_path__ + "static/media/saint-gobain-logo-charcoal.ef1ec8a1.svg";